module.exports = __webpack_public_path__ + "img/game_main_pc_221_off.ab47d97a.png";